import React from "react";
import { Link } from "react-router-dom";

// Reusable logo — placed on every page header + footer + auth screens
export default function BrandLogo({ size = "md", withText = true, className = "" }) {
  const sizes = {
    sm: { img: "h-8 w-8", title: "text-sm", tag: "text-[9px]" },
    md: { img: "h-10 w-10", title: "text-base", tag: "text-[10px]" },
    lg: { img: "h-14 w-14", title: "text-lg", tag: "text-xs" },
  }[size];
  return (
    <Link to="/" className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img
        src="/logo.jpeg"
        alt="SS Europa by Amei"
        className={`${sizes.img} rounded-full object-cover ring-2 ring-[#0B3D91]/20 shadow-sm bg-[#071B4A]`}
      />
      {withText && (
        <div className="leading-tight">
          <div className={`font-display font-extrabold text-[#0B3D91] ${sizes.title}`}>SS Europa</div>
          <div className={`uppercase tracking-widest text-[#F97316] font-semibold ${sizes.tag}`}>by Amei</div>
        </div>
      )}
    </Link>
  );
}
